import { useTheme } from "@emotion/react";
import {
  Card,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useApp } from "../../contexts/AppContext";
import { useReport } from "../../contexts/ReportContext";
import CircularArcs from "../CircularArc";

export interface CycleCardProps {
  cycle: number;
  eggs: number;
  liveBirthChance: [number, number];
}

const CycleCard: React.FC<CycleCardProps> = ({
  cycle,
  eggs,
  liveBirthChance,
}) => {
  const { colorStyle } = useReport();
  const theme: any = useTheme();

  const { translate } = useApp();
  const translations = translate("eggfreeze");

  const range = (eggs: number) => {
    const from = eggs - 1;
    const to = eggs + 1;
    if (from < 0) {
      return `0-${to}`;
    }
    if (to < 1) {
      return `0-1`;
    }
    return `${from}-${to}`;
  };

  return (
    <Card sx={{ backgroundColor: "#ffffff", borderRadius: "12px" }}>
      <CardHeader
        title={
          <Typography
            variant="report.card.info.normal"
            sx={{ color: theme.palette.reportColorStyles[colorStyle].text }}
            align="center"
          >
            {translations.report.estimatedResults.ifYouDo}{" "}
            <strong>
              {cycle}{" "}
              {cycle === 1
                ? translations.report.estimatedResults.cycle
                : translations.report.estimatedResults.cycles}
            </strong>
          </Typography>
        }
        sx={{
          textAlign: "center",
          backgroundColor: theme.palette.reportColorStyles[colorStyle].light,
        }}
      ></CardHeader>
      <CardContent>
        <CircularArcs
          title={range(eggs)}
          unit={translate("general", "eggs")}
          level={cycle}
        />

        <Stack gap={1}>
          <Typography
            sx={{ color: theme.palette.reportColorStyles[colorStyle].text }}
            variant="report.card.info.title"
            color="text.secondary"
          >
            {translations.report.estimatedResults.liveBirthChance}
          </Typography>

          <Stack alignItems={"center"} gap={1} direction={"row"}>
            <Typography variant="report.card.info.large" align="center">
              {liveBirthChance[0]}%
            </Typography>
            <Typography
              variant="report.card.info.normal"
              color="text.secondary"
            >
              {translations.report.estimatedResults.atLeastOneLiveBirth}
            </Typography>
          </Stack>
        </Stack>

        <Stack gap={2}>
          <Stack gap={1} alignItems={"center"} direction={"row"}>
            <Typography variant="report.card.info.large">
              {liveBirthChance[1]}%
            </Typography>
            <Typography
              variant="report.card.info.normal"
              color="text.secondary"
            >
              {translations.report.estimatedResults.atLeastTwoLiveBirths}
            </Typography>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default CycleCard;
